// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
       api_url: 'https://vikandapi.ospbiz.com/api',
      // api_url: 'http://localhost:5097/api',
      //  api_url: 'https://localhost:7174/api',
              //  api_url: 'https://vikandqa-api.ospbiz.com/api',
    //   api_url: 'https://uatapi.vikandmedical.com/api',
  signalR_url: 'https://vikandapi.ospbiz.com/notificationHub',
  build: 'Development'
};
